import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class WorkGroupService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves list of work-groups.
     *
     * @datatask 2040
     * @datataskName sp_ws_p2_workgrp_select_list
     * @param params settings for list of work groups.
     * @returns promise containing list of work groups.
     */
    public async getWorkGroups(params?: GetWorkGroupsParams): Promise<WorkGroupItem[]> {
        return this.datatask.Post(2040, params);
    }
}

export interface GetWorkGroupsParams {
    operation_id?: string;
    factory_id?: string;
    businessco_no?: string | number;
}

export interface WorkGroupItem {
    workgrp_keyno: string;
    workgrp_name: string;
    orderby: string;
}
